import { createContext, useContext, type ReactNode } from 'react';
import type { CheckoutEnv } from '../model/checkout_env.js';

/*
 * The checkout's environment comes by the drawer's `env` prop; inside, it goes
 * down a context instead of crossing every piece as a prop. The kit exports
 * the provider (not the hook) for a host that composes checkout pieces outside
 * the drawer — the chat's one-click card reuses the traveler fields.
 */

const CheckoutEnvContext = createContext<CheckoutEnv | null>(null);

export function CheckoutEnvProvider({
  env,
  children,
}: Readonly<{ env: CheckoutEnv; children: ReactNode }>) {
  return <CheckoutEnvContext.Provider value={env}>{children}</CheckoutEnvContext.Provider>;
}

/** The checkout environment in scene. Outside the provider it is a mounting
 *  error, not a state: every piece here only exists inside it. */
export function useCheckoutEnv(): CheckoutEnv {
  const env = useContext(CheckoutEnvContext);
  if (!env) throw new Error('checkout: piece mounted outside the CheckoutEnvProvider');
  return env;
}
